//dependencias
import React, { Component } from 'react';

//componentes
import DescripcionEAction from './descripcionE'

class Index extends Component {

    render(){
        return(
            <div>
                <DescripcionEAction />
            </div>
        );
    }

}
export default Index;